import { CookieSettingsButton } from "@/components/legal/CookieSettingsButton";

export function TrustStrip() {
  return (
    <footer className="mx-auto w-full max-w-[1240px] border-t border-border px-6 pt-6 pb-9 text-[13px] text-muted-foreground sm:px-10">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-baseline sm:gap-7">
        <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-foreground">
          Pre-launch
        </span>
        <span>
          Built from research with UK claimant solicitors · For professional
          legal use only. Not legal or financial advice.
        </span>
      </div>
      <ul className="mt-3 flex flex-wrap items-center gap-x-6 text-[12px]">
        <li>
          <a
            href="/privacy"
            className="inline-flex min-h-[44px] items-center transition-colors hover:text-accent"
          >
            Privacy Policy
          </a>
        </li>
        <li>
          <a
            href="/cookies"
            className="inline-flex min-h-[44px] items-center transition-colors hover:text-accent"
          >
            Cookie Policy
          </a>
        </li>
        <li>
          <CookieSettingsButton className="inline-flex min-h-[44px] items-center transition-colors hover:text-accent" />
        </li>
      </ul>
    </footer>
  );
}
